import styled from 'styled-components';

const Time = styled.div<{ outdated?: boolean }>`
    background-color: white;
    border-bottom: 1px solid #bab9b9;
    color: ${({ outdated }) => (outdated ? '#F00' : '#083461')};
    font-weight: bold;
    padding: 5px;
`;

const Heading = styled.div`
    color: #083461;
    text-align: center;
    font-size: 18px;
    margin-bottom: 10px;
    font-weight: bold;
`;

const Table = styled.table`
    color: #083461;
    font-size: 14px;
    font-weight: bold;
    overflow: hidden;
    border-spacing: 2px;
    border-collapse: separate;
    margin: 0 auto;
`;

const InfoColCell = styled.td`
    text-align: center;
    padding: 3px;
`;

const InfoRowCell = styled.td`
    padding: 3px;
    padding-right: 10px;
`;

const DataCell = styled.td`
    text-align: center;
    padding: 3px;
    background-color: #eee;
`;

const Container = styled.div`
    height: 100%;
    display: flex;
    flex-direction: column;
`;

const HarbourDialContainer = styled.div`
    background-color: white;
    flex: 1;
    display: flex;
    flex-flow: wrap;
`;

const WindPanel = styled.div`
    flex: 1;
    min-width: 185px;
    padding: 10px;
    margin-bottom: 10px;
`;

const Whitespace = styled.div`
    margin: 10px;
    height: 20px;
    box-sizing: border-box;
`;

export { Container, DataCell, HarbourDialContainer, Heading, InfoColCell, InfoRowCell, Table, Time, Whitespace, WindPanel };
